import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class PolygonConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'width',
		];
	}

	get_modifier_keys(): string[] {
		return [
			'side_amount',
		];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length|number> {
		return {
			width: maximum_rectangle.get_shortest_side(),
			side_amount: 15,
		};
	}

	get_labels(): Record<string, string> {
		const { width, side_amount } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			width,
			side_amount,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			width: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			side_amount: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'straight';
	}
}
